<ng-container *ngIf="projectAlerts?.length > 0">
	<div class="alert-row-title row-title">
		<div class="alerts-title-icon" [ngClass]="{'active-alerts': project.activeAlertsCount > 0}">
			<div class="alert-icon">
				<mat-icon>notifications_none</mat-icon>
				<div class="date" *ngIf="project.activeAlertsCount > 0">
					{{project.activeAlertsCount}}
				</div>
			</div>
		</div>
		Alerts
	</div>
	<div class="alert-block div-block">
		<div class="alerts-div" *ngFor="let alert of projectAlerts">
			<app-project-alert [showProject]="false" [projectAlert]="alert"></app-project-alert>
		</div>
	</div>
</ng-container>